const POSITIVE_INTEGERS_PARTIAL = /^(\d+)?(\.)?(\d+)?$/;
const POSITIVE_INTEGERS = /^\d+(\.\d+)?$/;
const POSITIVE_WHOLE_NUMBERS = /^\d+?$/;
const NINE_DIGITS_ONLY = /^\d{0,9}$/;
const FIVE_DIGITS_ONLY = /^\d{0,5}$/;
const TWO_DIGITS_ONLY = /^[1-9][0-9]?(\.[0-9]{1,2})?$/;
const POSITIVE_DECIMAL_NUMBER_UPTO_TWO_DIGIT = /^(0|[1-9]\d?)(\.\d{0,2})?$/;
const NON_NEGATIVE_NUMBERS = /^[0-9]+(\.[0-9]+)?$/;

const Patterns = {
    POSITIVE_INTEGERS,
    POSITIVE_INTEGERS_PARTIAL,
    POSITIVE_WHOLE_NUMBERS,
    NINE_DIGITS_ONLY,
    FIVE_DIGITS_ONLY,
    TWO_DIGITS_ONLY,
    POSITIVE_DECIMAL_NUMBER_UPTO_TWO_DIGIT,
    NON_NEGATIVE_NUMBERS
}

export default Patterns;



